import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { Action } from '@/models/action.model';

class ActionsService extends BaseService {
  private url: string = '/api/action';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<Action>> {
    const res = await this.$http.get<Action>(`${this.url}/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async getList(): Promise<DataResponse<Action[]>> {
    const res = await this.$http.get<Action[]>(`${this.url}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async create(item: Partial<Action>): Promise<DataResponse<Action>> {
    const res = await this.$http.post<Action>(this.url, item);

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(item: Action): Promise<DataResponse<Action>> {
    const res = await this.$http.put<Action>(`${this.url}/${item.id}`, item);

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new ActionsService();
